import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { RequisitionReviewPage } from '@/features/productRequisition/pages/RequisitionReviewPage';
import { requisitionReviewSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/specimen-requisition-review')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.SPECIMEN_REQUISITION_REVIEW_VIEW),
  validateSearch: requisitionReviewSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen Requisition Review">
      <Suspense fallback={<PageLoader />}>
        <RequisitionReviewPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
